import { Stack, Typography } from "@mui/material";
import {
  CollapseFade,
  STAGE_TRANSITION_MS,
} from "./CollapseFade";

/** The 48px the surrounding Stack puts between the orb and this copy. */
const LINE_GAP_PX = 48;

interface DisplayMessageProps {
  status: string;
  success?: boolean;
}

export function DisplayMessage({ status, success }: DisplayMessageProps) {
  return (
    <Stack sx={{ alignItems: "center" }}>
      <Typography
        aria-live="polite"
        sx={{
          fontFamily: "var(--font-sans)",
          fontWeight: 500,
          fontSize: "26px",
          lineHeight: "39px",
          textTransform: "uppercase",
          textAlign: "center",
          color: "hsla(0, 0%, 100%, 0.92)",
        }}
      >
        {success ? "A member of the treatment team is on their way" : status}
      </Typography>

      <CollapseFade
        open={Boolean(success)}
        spaceAbove={LINE_GAP_PX}
        delayMs={success ? STAGE_TRANSITION_MS : 0}
      >
        <Typography
          sx={{
            fontFamily: "var(--font-sans)",
            textAlign: "center",
            color: "hsla(0, 0%, 100%, 0.75)",
          }}
        >
          "I will notify a member of your treatment team for your request."
        </Typography>
      </CollapseFade>
    </Stack>
  );
}
